// Docs:
// https://reactjs.org/docs/state-and-lifecycle.html
// https://medium.com/@ruthmpardee/passing-data-between-react-components-103ad82ebd17

import React from 'react';
import { Datagrid, ReferenceField, ReferenceManyField, RichTextField, Show, ShowButton, Tab, TabbedShowLayout, TextField } from 'react-admin';
import { CustomShowActions } from './CustomActions';
import { BannerTemplatesTitle } from './BannerTemplatesTitle';

export class ConsentBannerShow extends React.Component {

  state = {
    relatedWebsites: {
      websites: null,
      ids: [],
    },
  };

  setRelatedWebsites = (websites, ids) => {
    this.setState({
      relatedWebsites: {
        websites: websites,
        ids: ids,
      },
    });
  };

  render() {
    return (
      <Show title={<BannerTemplatesTitle/>} {...this.props} actions={<CustomShowActions relatedWebsites={this.state.relatedWebsites}/>}>
        <TabbedShowLayout>

          <Tab label="summary">
            <TextField source="name"/>

            <ReferenceField label="Account" source="account" reference="accounts" allowEmpty>
              <TextField source="name"/>
            </ReferenceField>

            <ReferenceManyField label="Related websites" reference="websites" target="popUpTemplate">
              <DatagridReturningData callbackFromParent={this.setRelatedWebsites}/>
            </ReferenceManyField>
          </Tab>

          <Tab label="Source code">
            <RichTextField source="html" label="Html - all tags are stripped in this view, see it all in edit mode"
              stripTags/>

            <RichTextField source="css"/>

            <RichTextField source="js"/>

            <TextField source="displayBannerFunctionName"/>

            <TextField source="hideBannerFunctionName"/>
          </Tab>

        </TabbedShowLayout>
      </Show>
    );
  };
};

class DatagridReturningData extends React.Component {
  componentWillReceiveProps(newProps) {
    if (this.propChanged('data', this.props, newProps) || this.propChanged('ids', this.props, newProps)) {
      this.props.callbackFromParent(newProps.data, newProps.ids);
    }
  };

  propChanged(propName, oldProps, newProps) {
    return oldProps[propName] == null && newProps[propName] != null;
  }

  render() {
    if (this.props.ids && this.props.ids.length > 0) {
      return (
        <Datagrid basePath={this.props.basePath} data={this.props.data} currentSort={this.props.currentSort} ids={this.props.ids} {...this.props}>
          <TextField label="Name" source="name" sortable={false}/>
          <ShowButton/>
        </Datagrid>
      );
    } else {
      return (
        <div>No related websites</div>
      );
    }
  };
};
